<template>
  <div class="infor_box">
    <div class="title">{{$t('lang.zcxx')}}</div>
    <div class="form_box">
      <form action="">
        <input type="text" v-validate="'required'"  :class="[{ error: errors.has('name') }]" name="name" v-model="name" :placeholder="$t('lang.name') + ' ' + $t('lang.true')">
        <input type="text" v-validate="'required'" :class="[{ error: errors.has('company') }]" name="company" v-model="company" :placeholder="$t('lang.company')">
        <input type="text" v-validate="'required'" :class="[{ error: errors.has('title') }]" name="title" v-model="title" :placeholder="$t('lang.title')">
        <input type="text" v-validate="'required|email'" :class="[{ error: errors.has('email') }]" name="email" v-model="email" :placeholder="$t('lang.email')">
        <input type="text" name="tel" v-model="tel" :placeholder="$t('lang.tel')">
      </form>
    </div>
    <div class="industry_box">
      <div class="ind_title">{{$t('lang.hy')}}<span>{{$t('lang.three')}}</span></div>
      <div class="ind_tabs" v-if="$i18n.locale === 'zh'">
        <div :class="selectIndex.indexOf(index) !== -1 ? 'ind_tab active' : 'ind_tab'" v-for="(item, index) in tabs" :key="item" @click="selectTab(index, item)">
          {{item}}
        </div>
      </div>
      <div class="ind_tabs" v-else>
        <div :class="selectIndex.indexOf(index) !== -1 ? 'ind_tab active' : 'ind_tab'" v-for="(item, index) in tabs_en" :key="item" @click="selectTab(index, item)">
          {{item}}
        </div>
      </div>
    </div>
    <div class="confirm" @click="register"><span>{{$t('lang.tj')}}</span></div>
  </div>
</template>
<style lang="less" scoped>
@import "infor.less";
</style>
<script>
import ModalApi from '../../components/ModalApi'
export default {
  mixins: [ModalApi],
  data () {
    return {
      tabs: ['人工智能', '数字营销', '企业级应用', '医疗', '教育', '金融科技', '投资', '文创娱乐', '区块链', '智能硬件', '云与大数据', '新零售', '智能出行', 'VR/AR', '移动应用', '游戏', '软件开发及服务', '政府园区', '媒体', '其他'],
      tabs_en: ['AI', 'Blockchain', 'Cloud/Big Data', 'Digital Marketing', 'Enterprise Applications', 'FinTech', 'Games', 'Intelligent Mobility', 'Intelligent Hardware', 'Mobile Applications', 'Media', 'New Retail', 'Smart Medical', 'Smart Education,Investment', 'Pan Entertainment', 'VR/AR', 'Software Development', 'Other'],
      selectIndex: [],
      selectItem: [],
      name: '',
      title: '',
      company: '',
      email: '',
      tel: ''
    }
  },
  created () {
    let self = this
    console.log(this.$store.state.login.token)
    if (self.$i18n.locale === 'zh') {
      self.tel = localStorage.getItem('tel')
    } else {
      self.email = localStorage.getItem('email')
    }
  },
  methods: {
    selectTab: function (index, item) {
      let self = this
      let indexof = self.selectIndex.indexOf(index)
      if (indexof === -1) {
        if (self.selectItem.length >= 3) {
          self.alert(self.$t('lang.three2'), self.$t('lang.ts'), self.$t('lang.qr'))
        } else {
          self.selectIndex.push(index)
          self.selectItem.push(item)
        }
      } else {
        self.selectIndex.splice(indexof, 1)
        self.selectItem.splice(indexof, 1)
      }
    },
    register: function () {
      let self = this
      self.$validator.validate().then(result => {
        if (result) {
          if (self.selectItem.length > 0) {
            let selectString = self.selectItem.join(',')
            // console.log(selectString)
            self.$http.post('https://goapi.gmic.cn/api/v1/profile', {
              full_name: self.name,
              title: self.title,
              company: self.company,
              email: self.email,
              contact_mobile: self.tel,
              industry: selectString
            }).then(function (res) {
              // console.log(res)
              self.$store.commit('setFinishStatus', true)
              if (self.$i18n.locale === 'zh') {
                self.alert({slot: 'slotA'}, '加入 GMIC 交流社群', '确认', function () {
                  self.$router.replace({
                    path: '/'
                  })
                })
              } else {
                self.alert('You have successfully registered!', 'Notice', 'Confirm', function () {
                  self.$router.replace({
                    path: '/'
                  })
                })
              }
            }).catch(function (err) {
              console.log(err)
              self.alert(self.$t('lang.error'), self.$t('lang.ts'), self.$t('lang.qr'))
            })
          } else {
            self.alert(self.$t('lang.one'), self.$t('lang.ts'), self.$t('lang.qr'))
          }
        } else {
          self.alert(self.$t('lang.notfull'), self.$t('lang.ts'), self.$t('lang.qr'))
          // self.confirm({slot: 'slotB'})
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/infor/infor.vue